import type { BrandFeatures } from 'apiTypes/BrandFeatures'

import type { BrandMetadata } from 'server/brandMetadata'

import type { UserMetadata } from './stepHandler'

export enum StepType {
	Authentication = 'AUTHENTICATION',
	Introduction = 'INTRODUCTION',
	Terms = 'TERMS',
	Accounts = 'ACCOUNTS',
	MissingCoapplicant = 'MISSING_COAPPLICANT',
	BudgetEditForm = 'BUDGET_EDIT_FORM',
	Success = 'SUCCESS',
	Unauthorized = 'UNAUTHORIZED',
	Expired = 'EXPIRED',
	Disabled = 'DISABLED',
}

export type Step =
	| { type: StepType.Authentication; isLoginInvalid?: boolean }
	| {
			type: StepType.Introduction
			budgetId: string
			brandMetadata: BrandMetadata
			brandFeatures: Array<BrandFeatures>
			userMetadata: UserMetadata
	  }
	| {
			type: StepType.Terms
			budgetId: string
			brandMetadata: BrandMetadata
			brandFeatures: Array<BrandFeatures>
			userMetadata: UserMetadata
	  }
	| {
			type: StepType.Accounts
			budgetId: string
			brandFeatures: Array<BrandFeatures>
			userMetadata: UserMetadata
			isBankDataReceived: boolean
	  }
	| { type: StepType.MissingCoapplicant; userMetadata: UserMetadata }
	| { type: StepType.BudgetEditForm; budgetId: string; brandFeatures: Array<BrandFeatures>; userMetadata: UserMetadata }
	| { type: StepType.Success; userMetadata: UserMetadata }
	| { type: StepType.Unauthorized }
	| { type: StepType.Expired }
	| { type: StepType.Disabled }
